import { useState, useEffect } from "react";
import { useAdminApi, PASS_LABELS, toLocalDateStr, fmtMoney, exportXLSX } from "../../adminUtils";
import ExportBar from "./ExportBar";

export default function RevenueReport() {
  const { API, AUTH } = useAdminApi();
  const today  = toLocalDateStr(new Date());
  const [rangeEnd, setRangeEnd] = useState(today);
  const [revenue, setRevenue]   = useState(null);
  const [loading, setLoading]   = useState(false);

  const rangeStart = (() => { const d = new Date(`${rangeEnd}T12:00:00`); d.setDate(d.getDate() - 13); return toLocalDateStr(d); })();
  const shiftRange = dir => { const d = new Date(`${rangeEnd}T12:00:00`); d.setDate(d.getDate() + dir * 14); setRangeEnd(toLocalDateStr(d)); };

  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setLoadError(false);
    fetch(`${API}/reports/revenue?from=${rangeStart}&to=${rangeEnd}`, { headers: AUTH })
      .then(r => r.json()).then(rev => setRevenue(rev))
      .catch(() => setLoadError(true)).finally(() => setLoading(false));
  }, [rangeStart, rangeEnd, API, AUTH]);

  const doExport = () => {
    if (!revenue) return;
    const rows = [
      { Type: "Drop-in classes", Count: revenue.dropins.count, Total: revenue.dropins.total },
      ...Object.entries(revenue.passes ?? {}).map(([t, d]) => ({ Type: PASS_LABELS[t] ?? t, Count: d.count, Total: d.total })),
      { Type: "GRAND TOTAL", Total: revenue.grandTotal },
    ];
    exportXLSX("Revenue", rows, `florium-revenue-${rangeStart}-${rangeEnd}.xlsx`);
  };

  return (
    <div>
      <div className="adm-report-range">
        <button onClick={() => shiftRange(-1)}>← Prev</button>
        <span className="adm-range-label">{rangeStart} – {rangeEnd}</span>
        <button onClick={() => shiftRange(1)} disabled={rangeEnd >= today}>Next →</button>
      </div>
      {loading && <p className="adm-loading">Loading…</p>}
      {loadError && <p className="adm-error">Couldn't load revenue — check your connection and refresh.</p>}
      {revenue && !loading && (
        <>
          <ExportBar onXLSX={doExport} />
          <table className="adm-report-table">
            <thead><tr><th>Type</th><th>Count</th><th>Total</th></tr></thead>
            <tbody>
              <tr><td>Drop-in classes</td><td>{revenue.dropins.count}</td><td>{fmtMoney(revenue.dropins.total)}</td></tr>
              {Object.entries(revenue.passes ?? {}).map(([t, d]) => (
                <tr key={t}><td>{PASS_LABELS[t] ?? t}</td><td>{d.count}</td><td>{fmtMoney(d.total)}</td></tr>
              ))}
            </tbody>
            <tfoot><tr className="adm-report-subtotal"><td colSpan={2}>Total</td><td>{fmtMoney(revenue.grandTotal)}</td></tr></tfoot>
          </table>
        </>
      )}
    </div>
  );
}
